import mount from './entry';
import config from './config';
const el = document.getElementById(config.tag);
if (el) {
    mount(el, {
        device: config.platform
    });
}
